// extracted by mini-css-extract-plugin
export var alternate = "_i-j";
export var black = "_i-6";
export var blue = "_i-f";
export var blueLight = "_i-e";
export var brand = "_i-8";
export var darkMode = "_i-b";
export var error = "_i-a";
export var gray = "_i-5";
export var grayBlue = "_i-d";
export var iconWrapper = "_i-3";
export var inactive = "_i-7";
export var indigo = "_i-g";
export var orange = "_i-i";
export var pink = "_i-h";
export var primary = "_i-0";
export var purple = "_i-9";
export var success = "_i-4";
export var warning = "_i-c";
export var white = "_i-1";
export var whiteSuccess = "_i-2";